"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getStrikeRate = (props) => {
    if (props.pairs && props.pairs.isPairsGame) {
        if (props.pairs.timesOut === undefined)
            props.pairs.timesOut = 0;
        if (props.pairs.maxWickets === undefined)
            props.pairs.maxWickets = 0;
        if (props.pairs.runsLost === undefined)
            props.pairs.runsLost = 0;
        const tO = props.pairs.timesOut > props.pairs.maxWickets && props.pairs.maxWickets !== 0
            ? props.pairs.maxWickets
            : props.pairs.timesOut;
        return Number((((props.runs + tO * props.pairs.runsLost) / props.balls) * 100).toFixed(2));
    }
    else {
        if (props.runs === 0 && props.balls === 0)
            return 0.0;
        return Number(((props.runs / props.balls) * 100).toFixed(2));
    }
};
exports.default = getStrikeRate;
//# sourceMappingURL=getStrikeRate.js.map